import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createScoutSlice } from '../pages/Scout/store/scoutSlice';
import { createVideoSlice } from '../components/Video/store/videoSlice';
import { createPlayerSlice } from '../pages/player/store/playerSlice';
import { createTeamSlice } from '../pages/team/store/teamSlice';

export const STORE_SESSION_KEY = 'scoutZustandState';
export const WHATS_NEW_VIDEO_ID = 'whatsNew202610';

export const useStore = create(
  persist(
    (set, get) => ({
      ...createPlayerSlice(set, get),
      ...createTeamSlice(set),
      ...createScoutSlice(set, get),
      ...createVideoSlice(set),
      // --- Misc ---
      // --- State ---
      toast: { title: '', message: '', type: 'success' },
      showToast: false,
      whatsNewModalOpen: false,
      // --- Actions ---
      setToast: (toast, open) => {
        set({ toast, showToast: open });
      },
      setToastVisibility: (open) => {
        set({ showToast: open });
      },
      checkWhatsNewModalOpen: (account) => {
        if (!account) return;
        const hasSeenModal =
          account.releaseModal && account.releaseModal[WHATS_NEW_VIDEO_ID];
        set({ whatsNewModalOpen: !hasSeenModal });
      },
      setWhatsNewModalOpen: async (open, { save, account } = {}) => {
        set({ whatsNewModalOpen: open });
        if (!open && save && account) {
          await save({
            releaseModal: {
              ...(account?.releaseModal || {}),
              [WHATS_NEW_VIDEO_ID]: new Date().toISOString(),
            },
          });
        }
      },
    }),
    {
      name: STORE_SESSION_KEY,
      getStorage: () => localStorage,
    },
  ),
);
